export default class AuthService {
	constructor() {
		this.auth = firebase.auth()
		this.ref = firebase.database().ref()
	}

	get currentUser() {
		return this.auth.currentUser
	}

	getOrCreateUser() {
		return Promise.resolve(this.currentUser || this.signInAnonymously())
	}

	listenToAuth(callback) {
		return this.auth.onAuthStateChanged(callback)
	}

	getRedirectResult() {
		return this.auth.getRedirectResult().then((result) => {
			if (result.credential) {
				const token = result.credential.accessToken
				console.log('getRedirectResult.token', token)
			}
		}).catch((error) => {
			if (error.code === 'auth/credential-already-in-use') {
				return this.auth.signInWithCredential(error.credential)
			}
			throw error
		})
	}

	signInAnonymously() {
		return this.auth.signInAnonymously()
	}

	signInWithProvider(provider) {
		const { currentUser } = this.auth
		if (currentUser && currentUser.isAnonymous) {
			currentUser.linkWithRedirect(provider)
		} else {
			this.auth.signInWithRedirect(provider)
		}
	}

	signInWithFacebook() {
		const provider = new firebase.auth.FacebookAuthProvider()
		this.signInWithProvider(provider)
	}

	signInWithGoogle() {
		const provider = new firebase.auth.GoogleAuthProvider()
		this.signInWithProvider(provider)
	}

	signOut() {
		return this.auth.signOut()
	}
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js